import React, { useState, FC } from 'react';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { TextField, IconButton, Popover, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles(({breakpoints}) => 
    createStyles({
        root: {
            '& .MuiPaper-root': {
                top: '9px !important',
                left: '300px !important',
                right: '125px !important',
                [breakpoints.down('md')]: {
                    left: '15px !important',
                    right: '0px !important'
                }
            }
        },
        input: {
            backgroundColor:'white', 
            border: '0',
            width: '100%'
        },
    })
);

interface Props {
    placeholder: string;
}

export const SearchBarComponent: FC<Props> = (props: Props) => {
    const classes = useStyles();
    const [keyword, setKeyword] = useState('');
    const history = useHistory();

    const submitHandler = (e:any) => {
        if (!keyword.trim()) {
            return;
        }

        if(e.key === 'Enter'){
            history.push(`/search/${keyword.trim()}`);
            setKeyword('');
            setAnchorEl(null);
        } else if (e.key === undefined){
            history.push(`/search/${keyword.trim()}`);
            setKeyword('');
            setAnchorEl(null);
        }
    }

    const handleOnChange = (e:any) => {
        const validation = /^[0-9a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/;

        if(e.target.value === "" || validation.test(e.target.value)){
            setKeyword(e.target.value);
        }
    }

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <form onSubmit={submitHandler} className={classes.root}>
            <Popover
                className={classes.root}
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
            >
                <TextField
                    id='input'
                    fullWidth={true}
                    onKeyPress={submitHandler}
                    placeholder='Buscar en nuestra tienda'
                    className={classes.input}
                    variant='outlined'
                    value={keyword}
                    onChange={handleOnChange}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={submitHandler}>
                                    <SearchIcon/>
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
            </Popover>
            <IconButton onClick={handleClick}  aria-label="search">
                    <SearchIcon style={{color: "white"}} />
            </IconButton>
        </form>
    );
}